import { ReactComponent as CalendarEditIcon } from 'assets/icons/time/calendar-edit.svg';
import { ReactComponent as ClockIcon } from 'assets/icons/time/clock.svg';

export const time = {
  'calendar-edit': CalendarEditIcon,
  clock: ClockIcon,
};
